import { Pivot, PivotItem, Text } from "@fluentui/react";
import { useEffect, useState } from "react";
import { EntityQuery, is, LegalPerson, LinkedEntityQuery, Query, RelationshipDirection, Subsidiary, Address, from, and, Building } from "@the-real-insight/tri-model";
import { userAPI } from "../UserAPI";
import InfoList from "./InfoList";
import { useTranslation } from "react-i18next";
interface Properties {
  legalPerson?: LegalPerson;
  processError?: (error: any) => void;
}

export default function LegalPersonProperties(properties: Properties) {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);
  const [legalPerson, setLegalPerson] = useState() as any;
  const [headquarters, setHeadquarters] = useState() as any;

  const setParams = (value: any) => {
    console.log('Value >>>', value);

    const url = new URL(window.location.href);

    url.searchParams.set('tab', value.props.itemKey);
    window.history.replaceState(null, '', url.toString());

    setTab(value.props.itemKey);
  };

  useEffect(() => {
    if (!properties.legalPerson) {
      return;
    }

    const call = async () => {
      const legalPerson: any = await userAPI.queryOne(new Query(new EntityQuery(LegalPerson.type, [], undefined,
        // @ts-ignore
        is('_id').equal(`${properties.legalPerson._id}`)), [new LinkedEntityQuery('headquarters', RelationshipDirection.out, Address.type)]));

      console.log('Legal person >>>', legalPerson);

      setLegalPerson(legalPerson);

      if (legalPerson.headquarters) {
        const building: any = await userAPI.queryOne(from(Address.type).where(and(is('street').equal(legalPerson.headquarters.street),
          is('streetNumber').equal(legalPerson.headquarters.streetNumber), is('postalCode').equal(legalPerson.headquarters.postalCode), is('city').equal(legalPerson.headquarters.city)))
          .link('address', RelationshipDirection.in, Building.type));

        console.log('Building >>>', building);

        setHeadquarters(building);
      }

      const legalPersonWithSubsidiaries: any = await userAPI.queryOne(new Query(new EntityQuery(LegalPerson.type, [], undefined,
        // @ts-ignore
        is('_id').equal(`${properties.legalPerson._id}`)), [new LinkedEntityQuery('subsidiaries', RelationshipDirection.out, Subsidiary.type)]));

      if (legalPersonWithSubsidiaries) {
        console.log('Legal persons >>>', legalPersonWithSubsidiaries);

        setLegalPerson({ ...legalPerson, subsidiaries: legalPersonWithSubsidiaries.subsidiaries });
      }
    };

    call();
  }, [properties]);

  return (legalPerson
    ?
    <div>
      <div>
        <Text variant="medium">Company</Text>
      </div>
      <div>
        <Text variant="xxLarge">{legalPerson.name}</Text>
      </div>
      <div>
        <Pivot className="marginTopM" onLinkClick={setParams} selectedKey={String(tab)} overflowBehavior={'menu'}>
          <PivotItem itemKey="general" headerText={'General'} itemIcon="Info">
            <div className="marginTopM">
              <InfoList list={[{
                label: t('legalPersonPropertiesPanel.purpose'),
                value: legalPerson.purpose,
              }, {
                label: t('legalPersonPropertiesPanel.headquarters'),
                value: `${legalPerson.headquarters.street} ${legalPerson.headquarters.streetNumber}, ${legalPerson.headquarters.postalCode} ${legalPerson.headquarters.city}`,
                navigationLink: headquarters ? `/entity?selectedEntityType=Building&selectedEntity=${headquarters._id}` : null,
              }, {
                label: t('legalPersonPropertiesPanel.founded'),
                value: legalPerson.started ? new Date(legalPerson.started).toLocaleDateString() : '-',
              }, {
                label: t('legalPersonPropertiesPanel.tradeRegisterId'),
                value: legalPerson.tradeRegisterId,
              }, {
                label: t('legalPersonPropertiesPanel.tradeRegisterCity'),
                value: legalPerson.tradeRegisterCity,
              }, {
                label: t('legalPersonPropertiesPanel.website'),
                value: legalPerson.website ? legalPerson.website : '-',
                link: legalPerson.website,
              },
              ]} valueWidth="350px"></InfoList>
            </div>
          </PivotItem>
          <PivotItem itemKey="subsidiaries" headerText={'Niederlassungen'} itemIcon="MapPin">
            {legalPerson.subsidiaries && legalPerson.subsidiaries.length > 0
              ?
              <></>
              :
              <div className="marginTopM">Keine Daten zu Niederlassungen verfügbar.</div>
            }
          </PivotItem>
          <PivotItem itemKey="management" headerText={'Geschäftsführung'} itemIcon="Admin">
            {legalPerson.generalManagers && legalPerson.generalManagers.length > 0
              ?
              <></>
              :
              <div className="marginTopM">Keine Daten zur Geschäftsführung verfügbar.</div>
            }
          </PivotItem>
        </Pivot>
      </div>
    </div>
    :
    <></>
  );
}
